import { Validator } from 'vee-validate';

Validator.extend('cuit', {
    validate(value) {
        return VerifyCuit(value);
    }
});

Validator.extend('cbu', {
    validate(value) {
        return ValidateLengthCBU(value) && ValidateBankCode(value.substring(0, 8)) && ValidateAccount(value.substring(8));
    }
});

Validator.extend('tn', {
    validate(value) {
        return ValidateNumbers(value) && ValidateText(value);
    }
});

/** Códigos `banks.code` en BO.json para YAPE / YOLO / YA ESTA (Jet Perú). Actualizar si Jet Perú asigna otros. */
window.BO_JETPERU_WALLET_BANK_CODES = ['2037', '2038', '2039'];

/** Billeteras BO Jet Perú: celular 8 dígitos, inicio 6 o 7 */
Validator.extend('bo_wallet_phone', {
    validate(value) {
        const s = value != null ? String(value).trim() : '';
        return /^[67]\d{7}$/.test(s);
    }
});

function VerifyCuit(cuit) {
    if (cuit.length !== 11) { return false;}

    let n = 0;
    let digits = cuit.split('');
    let digit = parseInt(digits.pop());

    for (let i = 0; i < digits.length; i++) {
        n += digits[9 - i] * (2 + (i % 6));
    }

    let verify = 11 - (n % 11);
    if (verify === 11) {
        verify = 0;
    } else if (verify === 10) {
        verify = 9;
    }

    return digit === verify;
}

function ValidateLengthCBU(cbu) {
    return cbu.length === 22;
}

function ValidateBankCode(code) {
    if (code.length !== 8) { return false }

    const bank = code.substring(0, 3);
    const verify_1 = code[3];
    const branch = code.substring(4, 7);
    const verify_2 = code[7];

    const result = bank[0] * 7 + bank[1] * 1 + bank[2] * 3 + verify_1 * 9 + branch[0] * 7 + branch[1] * 1 + branch[2] * 3;

    const difference = 10 - (result % 10);

    return difference == verify_2;
}

function ValidateAccount(account) {
    if (account.length !== 14) { return false }

    const verify = account[13];
    const result = account[0] * 3 + account[1] * 9 + account[2] * 7 + account[3] * 1 + account[4] * 3 + account[5] * 9 + account[6] * 7 + account[7] * 1 + account[8] * 3 + account[9] * 9 + account[10] * 7 + account[11] * 1 + account[12] * 3;
    const difference = 10 - (result % 10);

    return difference == verify;
}

const numbers = "0123456789";
function ValidateNumbers(value){
    for (let i = 0; i < value.length; i++) {
        if (numbers.indexOf(value.charAt(i), 0) !== -1) {
            return true;
        }
    }
    return false;
}

const text = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
function ValidateText(value){
    for (let i = 0; i < value.length; i++) {
        if (text.indexOf(value.charAt(i), 0) !== -1) {
            return true;
        }
    }
    return false;
}
